import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import apis from '@/pages/mvp-panel/participant-data/apis.js';
import {  message, Tooltip } from '@drip/drip-design';
// @ts-ignore
import { Table, TableFormatterName, TableFormatterOperation, TableFormatterRank, TableFormatterRatioBar, TableFormatterTag, TableFormatterCurrency, Tag, Loading, Space, Button, Tooltip as JTMDTooltip, Label, Alert } from '@jd/jmtd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ALL_TARGET_MAP } from '@/pages/mvp-panel/participant-data/components/sku-analysis/components/target-select/constant/index.tsx';
import { formatPrice, formatNumber } from '@/common/utils';
import _ from 'lodash';
import { filterConditions } from '@/common/utils';
import { replaceRow, HIDESPU } from './func';
import DownLoadModal from '@/pages/mvp-panel/participant-data/components/sku-analysis/components/download-modal';
import DrawerTable from '@/pages/mvp-panel/participant-data/components/sku-analysis/components/drawerTable';
// @ts-ignore
import { format } from '@jd/jmtd-tools/es/number';

const modelId_1_SKU = '98d727b7-105c-4f69-a60c-c1b337b9ded6'; //SKU一级列表(页面初始化及未点击任何下钻情况使用):
const modelId_1_SPU = '99e7e57e-c8ac-4917-9566-182aee0a898e'; //SPU一级列表

const modelId_1 = '1bf7aa39-13aa-4cfb-9e1b-ca207fbbfb18'; // 一级列表 1230迭代新增
const modelId_2 = 'c619b653-a7f9-4a88-9556-44d3d8763c2b'; // 二级列表
const modelId_3 = 'c0808563-129e-4e15-85dc-803e26346d4f'; // 三级列表
const modelId_4 = '51a3db64-ec27-45f2-a2e5-86bec2ebe898'; // 四级列表

// const sortKey = ['ge_deal_standard_deal_ord_amt'];

function SkuAnalysisTable(props: any) {
  const { conditions, filter } = props;
  const [tableData, setTableData] = useState({
    bos: [],
    total: 0,
    loading: false
  });
  const dftPagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: false
  };
  const dftSorter = {
    sortField: 'ge_deal_standard_deal_ord_amt',
    sortType: ''
  };
  const [pagination, setPagination] = useState(dftPagination);
  // 表格排序
  const [sorter, setSorter] = useState(dftSorter);
  //主表格数据
  const [handledDataSource, setDateSource] = useState<any>([]);

  const [childData, setChildData] = useState<any>([]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [downloadItem, setDownloadItem] = useState<any>(null);

  const [childLoading, setChildLoading] = useState<boolean>(false);

  // 查询一级表格的入参
  const [tableQuery, setTableQuery] = useState(conditions);

  // 查询子表的入参
  const [childQuery, setChildQuery] = useState<any>(null);

  // 打开诊断
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerItem, setDrawerItem] = useState<any>(null);

  let tips = window.localStorage.getItem(`__${props.erp}__handleClickShows__`);
  const [showed, setShowed] = useState(tips != 'true');
  function handleShowClick(){
    setShowed(false);
    window.localStorage.setItem(
      `__${props.erp}__handleClickShows__`,
      'true'
    )
  }

  useEffect(()=>{
    if(tips != 'true' && !_.isEmpty(props.erp)){
      setTimeout(handleShowClick, 20000 )
    }
  },[props.erp])

  useEffect(() => {
    const p = _.cloneDeep(conditions);
    if(props.skuGroupId != -1){
      p.skuGroupId = props.skuGroupId
    }
    // 外部查询条件变化时，清空子表查询条件
    setChildQuery(null);
    setChildData([]);
    setChildLoading( false );
    setTableQuery(p);
    setPagination(dftPagination);
    setSorter(dftSorter);
  }, [conditions, props.skuGroupId]);

  function TitleOperate(){
    return (
      <>
        <Label className="title-label">操作</Label>
      </>
    )
  };
  function AttentionBlock(_props: any) {
    const { attention, sku_id, spu_id, flow_item_detail_view_uv_ratio = null, ge_deal_standard_deal_ord_amt_ratio = null , ge_deal_standard_deal_sub_ord_qtty_ratio = null, rowIndex} = _props;
    const [_attention, setAttention] = useState(attention);
    let empty = false;
    if((flow_item_detail_view_uv_ratio == null && ge_deal_standard_deal_ord_amt_ratio == null && ge_deal_standard_deal_sub_ord_qtty_ratio == null))
    {
      empty = true
    }
    /**更改关注状态 */
    function changeFollowStatus(val: any) {
      apis
        .goodsAnalysisItemFollow({ ...filter, itemType: conditions.itemType, ...val })
        .then((res) => {
          const { ret, msg } = res;
          if (ret !== '0') throw msg || '操作失败';
          message.success('操作成功');

          setAttention(!_attention);
        })
        .catch((ex) => {
          message.error(ex);
        });
    }

    function changeDrawerVisible(){
      const { item_cate_name_1, item_cate_name_2, item_cate_name_3, item_cate_name_4 } = _props;
      const ratio = _props[`${sorter.sortField}_ratio`];
      const type = ratio > 0 ? '增长' :  ratio < 0 ? '下降' : ratio == 0 ? '保持' : '空'//    type: 0, //1 增长,0保持, -1下降,
      const cate_name =
        '' +
        item_cate_name_1 +
        (item_cate_name_2 ? '|' + item_cate_name_2 : '') +
        (item_cate_name_3 ? '|' + item_cate_name_3 : '') +
        (item_cate_name_4 ? '|' + item_cate_name_4 : (item_cate_name_3 ? '|' + item_cate_name_3 : ''));

      props.handleCustomLog && props.handleCustomLog(['yx_center', 'SKUDiagnosticEntry', `{"metric":"${(sorter.sortField)}", "trend":"${type}", "skuid":"${_props.sku_id}","brand":"${_props?.brand_name}", "category":"${cate_name}"}`]);
      setDrawerItem(_props)
      setDrawerVisible(true);

    }
    return (
      <Space vertical size='small' className='mvp-table-space'>
        {
          empty &&  tableQuery.itemType == '1' && tableQuery.userType == 'placeErp' &&
          <JTMDTooltip placement='left' title='对比时间暂无数据，不支持诊断' theme='light'>
            <Label className='mvp-table-label'  size='mini'>诊断</Label>
          </JTMDTooltip>
        }
        {
          !empty  && tableQuery.itemType == '1' && tableQuery.userType == 'placeErp' &&
          <JTMDTooltip placement='left' title='点击查看商品诊断的结果。建议预先设定好对比时间' theme='light'>
            {/*<Label className='mvp-table-normal-label' size='mini' onClick={()=>{changeDrawerVisible()}}>诊断</Label>*/}
            <Button className='mvp-table-normal-label' link style={{width: '66px'}} semantic='primary' size='mini' onClick={()=>{changeDrawerVisible()}}>诊断</Button>
          </JTMDTooltip>
        }

        <Button className='mvp-table-normal-label' link semantic='primary' size='mini' outline style={{width: '66px'}} onClick={() => {
          setModalVisible(true);
          setDownloadItem(_props);
        }}>
          导出
        </Button>
        {/*<Label className='mvp-table-normal-label' size='mini' onClick={() => {*/}
        {/*  setModalVisible(true);*/}
        {/*  setDownloadItem(_props);*/}
        {/*}}>导出</Label>*/}
        {/*<Label className='mvp-table-normal-label' size='mini' onClick={() => changeFollowStatus({ action: _attention ? 2 : 1, itemId: sku_id || spu_id })}> {_attention ? '取消关注' : '关注'}</Label>*/}
        <Button className='mvp-table-normal-label' link semantic='primary' size='mini' outline style={{width: '66px'}}>
          <a onClick={() => changeFollowStatus({ action: _attention ? 2 : 1, itemId: sku_id || spu_id })}>
            {_attention ? '取消关注' : '关注'}
          </a>
        </Button>
      </Space>

    );
  }
  // 查询一级表格
  useEffect(() => {
    if (!tableQuery.indicators || !tableQuery.userType) return;
    let didMount = true;
    setTableData((val) => Object.assign({}, val, { loading: true }));

    const _tableQuery = _.cloneDeep(tableQuery);
    if (_tableQuery.itemType == '2') {
      // 根据sku和spu选择modelId
      _tableQuery.modelId = modelId_1_SPU;
      // spu要删去两个指标‘站外新，老用户’
      _tableQuery.indicators = _tableQuery.indicators.filter(
        (ele: string) => !HIDESPU.has(ele)
      );
    } else {
      _tableQuery.modelId = modelId_1_SKU;
    }
    _tableQuery.indicators = _.difference(_tableQuery.indicators, ['brand_name', 'item_cate_name_1', 'shop_name']);
    apis
      .queryGoodsAnalysis(_tableQuery)
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        // data.bos = data?.bos?.map((item:any)=>({...item,hasChildren:true}))
        setDateSource(data.bos);
        setPagination({
          ...pagination,
          total: data.total
        });
        setTableData(Object.assign({}, data, { loading: false }));
      })
      .catch((ex) => {
        message.error(ex);
        setTableData((val) => Object.assign({}, val, { loading: false }));
      });
    return () => {
      didMount = false;
    };
  }, [tableQuery]);

  // // 查询子表
  useEffect(() => {
    if (!childQuery) return;
    let didMount = true;
    apis
      .queryGoodsAnalysis(filterConditions(childQuery))
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        data.bos = data?.bos?.map((item:any)=>({...item,hasChildren: true, level: 0}))
        setChildData(data.bos);
        setChildLoading(false)
      })
      .catch((ex) => {
        message.error(ex);
        setChildData([]);
        setChildLoading(false)
      });
    return () => {
      didMount = false;
      setChildLoading(false)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childQuery]);

  const getColumns= useMemo(()=>{
    const { itemType, indicators } = conditions;
    const keyVal: { [key: string]: any } = {
      '1': { imgUrl: 'sku_img_url', name: 'sku_name', id: 'sku_id', key: 'SKU' },
      '2': { imgUrl: 'spu_img_url', name: 'spu_name', id: 'spu_id', key: 'SPU' }
    };
    let _columns = []
    _columns.push({
      dataIndex: `${keyVal[itemType].name}`,
      title: '商品信息',
      imgIndex: `${keyVal[itemType].imgUrl}`,
      idIndex: `${keyVal[itemType].id}`,
      idLabel: `${keyVal[itemType].key}`,
      formatter: TableFormatterName,
      affix: true,
    });
    if (_.indexOf(indicators, 'brand_name') > -1) {
      _columns.push({
        title: '品牌',
        dataIndex: 'brand_name',
      });
    }
    if (_.indexOf(indicators, 'item_cate_name_1') > -1) {
      _columns.push({
        title: '品类',
        dataIndex: 'item_cate_name_1',
        render: (text: any, record: any) => {
          const { item_cate_name_1, item_cate_name_2, item_cate_name_3, item_cate_name_4 } = record;
          const str =
            '' +
            item_cate_name_1 +
            (item_cate_name_2 ? '|' + item_cate_name_2 : '') +
            (item_cate_name_3 ? '|' + item_cate_name_3 : '') +
            (item_cate_name_4 ? '|' + item_cate_name_4 : (item_cate_name_3 ? '|' + item_cate_name_3 : ''));
          return str;
        }
      });
    }
    if (_.indexOf(indicators, 'shop_name') > -1) {
      _columns.push({
        title: '店铺',
        dataIndex: 'shop_name'
      });
    }

    if (_.indexOf(indicators, 'ge_deal_standard_deal_ord_amt') > -1) {
      _columns.push({
        title: '成交金额',
        dataIndex: 'ge_deal_standard_deal_ord_amt',
        formatter: TableFormatterCurrency,
        sorter: true,
        sortOrder: sorter.sortField === 'ge_deal_standard_deal_ord_amt' ? sorter.sortType || 'descend' : false,
      });
      _columns.push( {
        title: '较对比日',
        dataIndex: 'ge_deal_standard_deal_ord_amt' + '_ratio',
        formatter: TableFormatterTag,
      });
    }
    indicators?.map((item: string) => {
      // spu要删去两个指标‘站外新，老用户’
      if (conditions.itemType == '2' && HIDESPU.has(item))
        return;
      if(item == 'ge_deal_standard_deal_ord_amt') return;
      // if (item == 'ge_deal_standard_deal_ord_amt') return;
      if (item == 'shop_name' || item == 'item_cate_name_1' || item == 'brand_name') return;
      const col: any = {
        title: ALL_TARGET_MAP[item].label,
        dataIndex: item,
        align: 'right',
        render: (text: any, record: any) => {
          const showText = ALL_TARGET_MAP[item].show_text;
          if (showText) {
            return typeof (text) == 'undefined' ? '--' : text ? '是' : '否';
          }
          if (text === 0) return 0;
          const format = ALL_TARGET_MAP[item].format;
          const decimal = ALL_TARGET_MAP[item].decimal;
          const noRatio = ALL_TARGET_MAP[item].no_ratio;

          if (format) {
            return formatPrice(text * 100, '--', 1, format);
          } else if (noRatio) {
            return text ?? '--';
          }
          return formatNumber(text, '--', decimal, true);
        },
        // sorter: item == 'ge_deal_standard_deal_ord_amt'
        sorter: ALL_TARGET_MAP[item].sorter,
        sortOrder: sorter.sortField === item ? sorter.sortType || 'descend' : false,
      };
      if (!ALL_TARGET_MAP[item].no_ratio) {
        _columns.push(col, {
          title: '较对比日',
          dataIndex: item + '_ratio',
          // width: 120,
          formatter: TableFormatterTag,
        });
      } else {
        _columns.push(col);
      }

    });
    _columns.push({
      title: <TitleOperate/>,
      affix: 'right',
      width: 120,
      align: 'center',
      render: (text: any, record: any, index: any) => {
        record.rowIndex = index
        return <AttentionBlock {...record }/>;
      },

    });
    return _columns
  },[conditions, sorter])
  const handlePageChange = useCallback(({action, value}) => {
    let _val = {};
    if(action === 'paginate') {
      _val = { pageNo: value.current };
      setPagination(preState => {
        return {
          ...preState,
          ...value
        };
      });
      setTableQuery((val: any) => ({ ...val, ..._val }));
    } else if (action === 'sort') {
      const { column, order } = value;
      if(order){
        setSorter({
          sortField: column.dataIndex,
          sortType: order
        });
        _val = {
          orders: {
            propertyName: column.dataIndex,
            ascending: order === 'ascend'
          },
          pageNo: 1
        };
        setTableQuery((val: any) => ({ ...val, ..._val }));
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'MetricsSorting', `{"metric":"${column.dataIndex}", "rank":"${order}"}`]);
      }
      else{
        let _order = column.sortOrder == 'ascend' ? 'descend' : 'ascend';
        setSorter({
          sortField: column.dataIndex,
          sortType: _order
        });
        _val = {
          orders: {
            propertyName: column.dataIndex,
            ascending: _order === 'ascend'
          },
          pageNo: 1
        };
        setTableQuery((val: any) => ({ ...val, ..._val }));
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'MetricsSorting', `{"metric":"${column.dataIndex}", "rank":"${_order}"}`]);
      }
      // '营销中心-或主阵地-商品监控', `点击${column.dataIndex}的排序`, order

    } else if (action === 'expand') {
      if(!_.isEmpty(document.getElementById('participant-title-con'))){
        const btn = document.getElementById('participant-title-con')
        btn?.setAttribute("clsTag", 'h|keycount|yx_center_hzcp_1678258944439|19');
        // @ts-ignore
        btn.addEventListener('click', ()=>{console.log('触发yx_center_hzcp_1678258944439|19')});
        // @ts-ignore
        btn.click();
        // @ts-ignore
        btn.removeEventListener('click', ()=>{}, false)
        btn?.setAttribute("clsTag", '');
        btn?.removeAttribute("clsTag")
      }
      setChildData([]);
      setChildLoading(true)
      setDateSource(
        handledDataSource.map((record:any) => {
          if (record === value && !value.expanded){
            const _criteria = {
              ...tableQuery.criteria,
              sku_id: value.sku_id ? [value.sku_id] : '',
              spu_id: value.spu_id ? [value.spu_id] : ''
            };
            setChildQuery({
              ...tableQuery,
              criteria: filterConditions(_criteria),
              modelId: modelId_1, // 一级列表
              pageSize: null,
              pageNo: null
            });
          }
          return {
            ...record,
            expanded: record === value ? !value.expanded : false,
          }
        }),
      );
    }
  }, [handledDataSource]);

  // 子表头
  function getChildColumns(level: string, item: any, tableQuery: any) {
    const online = tableQuery?.dataType === 'REALTIME'
    let childColumn = [
      {
        title: <span >末次渠道来源<Tooltip title={'末次来源指的是以观测视角（商详）为中心点，提供用户行为中最近的一个场域引流效果；加工逻辑优先判别站内渠道，然后站外渠道。详见https://cf.jd.com/pages/viewpage.action?pageId=567256563'}>
                  <QuestionCircleOutlined style={{marginLeft: '5px'}}/>
                </Tooltip></span>,
        affix: true,
        width: 265,
        dataIndex: 'last_src_channel_name_' + level,
        render: (record: any) => <Label>{record}</Label>,
      },
      {
        title: '商详UV',
        dataIndex: 'flow_source_to_item_uv',
        align: 'right',
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_uv_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '商详PV',
        dataIndex: 'flow_source_to_item_pv',
        align: 'right',
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_pv_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '加购用户数',
        dataIndex: 'flow_source_to_item_cart_user_qtty',
        align: 'right',
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_cart_user_qtty_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '成交金额',
        dataIndex: 'flow_source_to_item_deal_ord_amt',
        align: 'right',
        render: (record: any) =>  _.isNumber(record) ? format(record, 'currency_¥') : '--',
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_deal_ord_amt_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '成交子单量',
        dataIndex: 'flow_source_to_item_detail_deal_sub_ord_qtty',
        align: 'right',
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_detail_deal_sub_ord_qtty_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '成交购买用户',
        dataIndex: 'flow_source_to_item_deal_user_qtty',
        align: 'right',
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_deal_user_qtty_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '成交数量',
        dataIndex: 'flow_source_to_item_deal_item_qtty',
        description: '成交口径下的商品数量，不按sku去重',
        align: 'right',
        online: true,
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_deal_item_qtty_ratio',
        formatter: TableFormatterTag,
        online: true,
      },
      {
        title: '成交客单价',
        dataIndex: 'fo_flow_source_to_item_pct',
        description: '成交金额/成交子单量',
        align: 'right',
        render: (record: any) => _.isNumber(record) ? format(record, 'currency_¥') : '--',
      },
      {
        title: '较对比日',
        dataIndex: 'fo_flow_source_to_item_pct_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '成交件单价',
        dataIndex: 'fo_flow_source_to_item_deal_item_value',
        description: '成交金额/成交件数',
        align: 'right',
        online: true,
        render: (record: any) =>  _.isNumber(record) ? format(record, 'currency_¥') : '--',
      },
      {
        title: '较对比日',
        dataIndex: 'fo_flow_source_to_item_deal_item_value_ratio',
        formatter: TableFormatterTag,
        online: true,
      },
      {
        title: '成交转化率',
        dataIndex: 'fo_flow_source_to_item_deal_user_cvr',
        description: '末次来源口径：成交转化率=成交客户数/商详UV',
        align: 'right',
        render: (record: any) => {
          if (isNaN(record)) return '--';
          if (record === 0) return record;
          return formatPrice(record * 100) + '%';
        }
      },
      {
        title: '较对比日',
        dataIndex: 'fo_flow_source_to_item_deal_user_cvr_ratio',
        formatter: TableFormatterTag,
      },
      {
        title: '出库金额',
        dataIndex: 'flow_source_to_item_ob_order_amt',
        align: 'right',
        online: true,
        render: (record: any) =>  _.isNumber(record) ? format(record, 'currency_¥') : '--',
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_ob_order_amt_ratio',
        formatter: TableFormatterTag,
        online: true,
      },
      {
        title: '出库件数',
        dataIndex: 'flow_source_to_item_ob_order_item_qtty',
        description: '出库口径下的商品数量，不按sku去重',
        align: 'right',
        online: true,
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_ob_order_item_qtty_ratio',
        formatter: TableFormatterTag,
        online: true,
      },
      {
        title: '出库子单量',
        dataIndex: 'flow_source_to_item_ob_sub_ord_qtty',
        align: 'right',
        online: true,
        render: (record: any) => formatNumber(record, '--', 0, true),
      },
      {
        title: '较对比日',
        dataIndex: 'flow_source_to_item_ob_sub_ord_qtty_ratio',
        formatter: TableFormatterTag,
        online: true,
      },
      {
        title: '出库件单价',
        dataIndex: 'fo_flow_source_to_item_ob_order_item_value',
        description: '出库金额/出库件数',
        align: 'right',
        online: true,
        render: (record: any) =>  _.isNumber(record) ? format(record, 'currency_¥') : '--',
      },
      {
        title: '较对比日',
        dataIndex: 'fo_flow_source_to_item_ob_order_item_value_ratio',
        formatter: TableFormatterTag,
        online: true,
      },

      // {
      //   title: <span style={{ color: ' #2d64ff', cursor: 'pointer' }} onClick={() => {
      //     setModalVisible(true);
      //     setDownloadItem(item);
      //   }}>导出数据</span>,
      //   width: 100,
      //   affix: 'right',
      //   render: () => <span></span>
      // }
    ];
    return online ? childColumn.filter(item=>(item?.online != true)) : childColumn;
  }

  // 处理子表格下钻
  // @ts-ignore
  const onHandleSubTable = ({ action, value }) => {
    if (action === 'treeExpand') {
      const name = value.level == 0 ? value.last_src_channel_id_1 : value.last_src_channel_id_2;
      const showName = value.level == 0 ? value.last_src_channel_name_1 : value.last_src_channel_name_2;

      const data = handledDataSource.filter((record:any) => {
          if (record.expanded){
            return record
          }
        })
      const { item_cate_name_1, item_cate_name_2, item_cate_name_3, item_cate_name_4, brand_name } = data?.[0];
      const cate_name =
        '' +
        item_cate_name_1 +
        (item_cate_name_2 ? '|' + item_cate_name_2 : '') +
        (item_cate_name_3 ? '|' + item_cate_name_3 : '') +
        (item_cate_name_4 ? '|' + item_cate_name_4 : (item_cate_name_3 ? '|' + item_cate_name_3 : ''));

      props.handleCustomLog && props.handleCustomLog(['yx_center', 'SourceDrillDown', `{"level":"${(value.level + 1)}", "name":"${showName}", "skuid":"${value.sku_id}", "brand":"${brand_name}", "category":"${cate_name}"}`]);
      // props.handleCustomLog(['yx_center', 'SourceDrillDown', '营销中心-或主阵地-商品监控', `展开${value.sku_id}后点击下钻${name}`, `所属渠道等级${(value.level + 1)}`, `渠道名称${name}`, `SKUID${value.sku_id}`, `品牌${value?.brand_name}`, `品类${cate_name}`])
      setChildData(replaceRow(childData, value, (record:any) => {
        let nextRow:any;
        if (record.hasChildren && !record.children) {
          nextRow = {
            ...record,
            childrenExpanded: 'loading'
          };
          const _criteria = {
            ...tableQuery.criteria,
            sku_id: record.sku_id ? [record.sku_id] : '',
            spu_id: record.spu_id ? [record.spu_id] : '',
          };
          if(value.level == 0){
            _criteria.last_src_channel_id_1 = record.last_src_channel_id_1
          } else if(value.level == 1){
            _criteria.last_src_channel_id_2 = record.last_src_channel_id_2
          } else if(value.level == 2){
            _criteria.last_src_channel_id_3 = record.last_src_channel_id_3
          }
          const query = {
            ...tableQuery,
            criteria: filterConditions(_criteria),
            modelId: value.level < 1 ? modelId_2 : value.level  == 1 ? modelId_3 : modelId_4, // 二级列表
            pageSize: null,
            pageNo: null
          };
          let level = value.level + 1;
          apis
            .queryGoodsAnalysis(filterConditions(query))
            .then((res) => {
              const { ret, msg, data } = res;
              if (ret !== '0' || !data) throw msg || '表格接口请求失败';

              //末级
              // last_src_page_active_id
              // last_src_page_active_name
              data.bos = data?.bos?.map((item:any)=>(
                {...item,
                  hasChildren: level < 2 || (item['last_src_channel_id_3'] == '2002004' && !item.hasOwnProperty('last_src_page_active_id')),
                  level,
                  last_src_channel_name_1 : level < 2 ? item.last_src_channel_name_2 : level  == 2 ? item.last_src_channel_name_3 : item.last_src_page_active_name
                }))
              setChildData((rows:any) => replaceRow(rows, nextRow, (loadingRow:any) => ({
                  ...loadingRow,
                  children: data.bos,
                  childrenExpanded: true
                })));
            })
            .catch((ex) => {
              message.error(ex);
              nextRow = {
                ...record,
                childrenExpanded: !record.childrenExpanded
              };
            });
        } else {
          nextRow = {
            ...record,
            childrenExpanded: !record.childrenExpanded
          };
        }
        return nextRow;
      }));
    }
  }
// 展开行渲染
  const expandedRowRender = (item:any) => {
    return (
      <>
        <Table key={JSON.stringify(childData)}
               columns={getChildColumns('1', item, tableQuery)}
               dataSource={childData}
               onChange={onHandleSubTable}
               loading={childLoading}
        />
      </>
    )
  };
  return (
    <React.Fragment>
      {
        tableQuery.userType == 'placeErp' &&
        <div className='main-table-tips-con' style={{display: !showed ? 'none' : 'block'}}>
          <Alert className='main-table-tips' title='点击查看商品诊断的结果。建议预先设定好对比时间' showIcon={false}
                 closable
                 closed={!showed}
                 theme='dark'
                 onClose={() => handleShowClick()}></Alert>
          <div className='main-table-arrow-content'></div>
        </div>
      }

      <Loading loading={tableData.loading}>

        <Table key={`${JSON.stringify(tableData.bos)}${JSON.stringify(conditions)}${JSON.stringify(sorter)}`}
               columns={getColumns}
               dataSource={handledDataSource}
               onChange={handlePageChange}
               expandable={{
                 expandedRowRender,
               }}
               pagination={{
                 ...pagination,
                 showTotal: (total:any) => `总共${total}条`
               }}
               id='mainTable'
        />
      </Loading>
      <DownLoadModal visible={modalVisible} setVisible={setModalVisible} conditions={conditions} item={downloadItem} downloadBySku={true} skuGroupId={props.skuGroupId} selObj={props.selObj}/>
      <DrawerTable
        visible={drawerVisible}
        filter={filter}
        conditions={conditions}
        tableQuery={tableQuery}
        drawerItem={drawerItem}
        modelId_1_SKU={modelId_1_SKU}
        modelId_1_SPU={modelId_1_SPU}
        setDrawerVisible={((value: any)=>(setDrawerVisible(value)))}
        placeList={props.placeList}
        planList={props.planList}
        selPlaceList={props.selPlaceList}
        selObj={props.selObj}
        erp={props.erp}
        sortField={sorter?.sortField}
        handleCustomLog={props.handleCustomLog}
        handleLog={props.handleLog}
      ></DrawerTable>
    </React.Fragment>

  );
}

export default SkuAnalysisTable;
